import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from "../hooks/useSetWidgetAttribute.js";
import SettingsSection from './common/SettingsSection.jsx';
import SelectSetting from './common/SelectSetting.jsx';
import SliderSetting from './common/SliderSetting.jsx';

function AutoHeightSettings({ widgetId }){
  const selectedObject = useSelector(state => state.dashboard.widgets[widgetId].settings);
  const setAttribute = useSetWidgetAttribute(widgetId);

  const widgetSettingProps = {
    prefix: '',
    selectedObject,
    widgetId,
    setAttribute: (path, val) => setAttribute(`settings.${path}`, val)
  };

  return (
    <>
      <SelectSetting
        {...widgetSettingProps}
        options={[
          {label: I18n.t('fixed'), value: 'fixed'},
          {label: I18n.t('auto'), value: 'auto'},
          {label: I18n.t('auto_with_max'), value: 'autoWithMax'}
        ]}
        attr='heightMode'
        label={I18n.t('height_mode')}
      />
      {selectedObject.heightMode === 'autoWithMax' &&
        <SliderSetting {...widgetSettingProps} attr='maxHeight' label={I18n.t('max_height_px')} max={2000} />
      }
    </>
  )
}

export default AutoHeightSettings;
